import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

const appTheme = document.getElementById('app-theme') as HTMLLinkElement;
const DARK_THEME = 'aura-dark-noir.css';
const APP_DARK_CLASS = 'app-dark-theme';

const ALLOWED_THEMES = new Set([
  'lara-light-teal.css',
  'nova.css',
  'aura-light-noir.css',
  'aura-dark-noir.css',
  'lara-light-indigo.css',
]);

const queryTheme = new URLSearchParams(window.location.search).get('theme');
const storedTheme = window.localStorage.getItem('app-theme');
const resolvedTheme = [queryTheme, storedTheme, environment.THEME].find(
  (theme): theme is string => !!theme && ALLOWED_THEMES.has(theme)
);

if (queryTheme && ALLOWED_THEMES.has(queryTheme)) {
  window.localStorage.setItem('app-theme', queryTheme);
}

const applyThemeModeClass = (themeHref: string) => {
  document.documentElement.classList.toggle(APP_DARK_CLASS, themeHref.includes(DARK_THEME));
};

const selectedTheme = resolvedTheme ?? environment.THEME;
appTheme.href = selectedTheme;
applyThemeModeClass(selectedTheme);

const observer = new MutationObserver(() => {
  applyThemeModeClass(appTheme.getAttribute('href') ?? '');
});
observer.observe(appTheme, { attributes: true, attributeFilter: ['href'] });

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
